'use client';

import type {HTMLChakraProps} from '@chakra-ui/react';
import {ChakraDiv, ChakraH4} from '@linx-security/ui/utils/chakra-elements';
import type {ReactNode} from 'react';
import {forwardRef} from 'react';

import type {WidgetContext} from './Container';
import {useStyles} from './context';

type Props = {
  title: string;
  img: ReactNode;
} & WidgetContext &
  HTMLChakraProps<'div'>;

export const WidgetEmpty = forwardRef(
  (
    {
      title,
      img,
      isInteractive: _isInteractive,
      isEmpty: _isEmpty,
      isLoading: _isLoading,
      hasError: _hasError,
      ...props
    }: Props,
    ref,
  ) => {
    const {empty} = useStyles();
    return (
      <ChakraDiv ref={ref} __css={empty} {...props}>
        <ChakraDiv w={`space-1000`} h={`space-1000`}>
          {img}
        </ChakraDiv>
        <ChakraH4 flex={1}>{title}</ChakraH4>
      </ChakraDiv>
    );
  },
);
